<template>
  <div class="component-archives-module-view">
    <div
      v-if="curIdx >= 0"
      :class="{
        'rounded-lg bg-black': isPlat,
      }"
    >
      <div
        v-for="(item, index) in list"
        :key="index"
        :class="{
          'py-2 px-4 border-0 border last:border-b-0 hover:': true,
          'py-2 px-4 bg-white mb-2 rounded-lg': true,
        }"
        v-if="item.name == '巡访小结' || item.name == '回访内容'"
        class="item"
      >
        <div v-if="item.isModule" class="border-0">
          <div class="text-lg leading-8 item-name">{{ item.name }}</div>
          <div
            v-for="(child, childIdx) in item.children"
            :key="childIdx"
            class="py-2 px-4 border-0 border-b last:border-b-0 active:bg-gray-100 border-gray-100 border-solid"
          >
            <div class="flex flex-row justify-between items-center">
              <div>
                <div class="text-lg leading-8 item-name">
                  {{ child.name }}
                </div>
                <div class="text-gray-500 text-base">
                  <div
                    v-for="(
                      moduleVal, moduleValIndex
                    ) in formateArchivesModuleValue(child, false)"
                    :key="moduleValIndex"
                  >
                    <span>{{ moduleVal.label }}</span>
                    <template
                      v-if="moduleVal && moduleVal.opt && moduleVal.opt.isFile"
                    >
                      <span class="align-middle">：</span>
                      <div
                        v-for="(val, valIdx) in moduleVal.value"
                        :key="valIdx"
                        class="inline-block mr-2 drop-shadow"
                      >
                        <el-image
                          v-if="
                            moduleVal &&
                            moduleVal.opt &&
                            moduleVal.opt.isImage(val.url)
                          "
                          :src="val.url"
                          :alt="val.name"
                          :preview-src-list="moduleVal.value.map((v) => v.url)"
                          preview-teleported
                          :initial-index="valIdx"
                          fit="cover"
                          class="h-12 w-12 rounded align-middle"
                        ></el-image>
                        <el-button
                          v-else
                          class="align-middle"
                          type="primary"
                          link
                          tag="a"
                          :download="val.name"
                          :href="
                            val.url +
                            '?response-content-type=application/octet-stream'
                          "
                          target="_blank"
                          >下载附件</el-button
                        >
                      </div>
                    </template>
                    <span v-else class="text-gray-400"
                      >：{{ moduleVal.value }}{{ moduleVal.unit }}</span
                    >
                    <div v-if="moduleVal.date">
                      <span>检查时间：</span
                      ><span class="text-gray-400">{{ moduleVal.date }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="flex flex-row justify-between items-center">
          <div>
            <div class="text-lg item-name">{{ item.name }}</div>
            <div v-if="item.isModule" class="pl-4">
              <div v-for="(child, childIdx) in item.children" :key="childIdx">
                <div>
                  <div
                    v-for="(
                      moduleVal, moduleValIndex
                    ) in formateArchivesModuleValue(child, false)"
                    :key="moduleValIndex"
                    class="py-2"
                    :class="{
                      'pl-2': moduleVal.isChild,
                    }"
                  >
                    <span>{{ moduleVal.label }} </span>
                    <template v-if="!moduleVal.isLabel">
                      <template
                        v-if="
                          moduleVal && moduleVal.opt && moduleVal.opt.isFile
                        "
                      >
                        <span class="align-middle">：</span>
                        <div
                          v-for="(val, valIdx) in moduleVal.value"
                          :key="valIdx"
                          class="inline-block mr-2 drop-shadow"
                        >
                          <el-image
                            v-if="
                              moduleVal &&
                              moduleVal.opt &&
                              moduleVal.opt.isImage(val.url)
                            "
                            :src="val.url"
                            :alt="val.name"
                            :preview-src-list="
                              moduleVal.value.map((v) => v.url)
                            "
                            preview-teleported
                            :initial-index="valIdx"
                            fit="cover"
                            class="h-12 w-12 rounded align-middle"
                          ></el-image>
                          <el-button
                            v-else
                            class="align-middle"
                            type="primary"
                            link
                            tag="a"
                            :download="val.name"
                            :href="
                              val.url +
                              '?response-content-type=application/octet-stream'
                            "
                            target="_blank"
                            >下载附件</el-button
                          >
                        </div>
                      </template>
                      <span v-else class="text-gray-400"
                        >：{{ moduleVal.value }}{{ moduleVal.unit }}</span
                      >
                    </template>
                    <div v-if="moduleVal.date">
                      <span>检查时间：</span
                      ><span class="text-gray-400">{{ moduleVal.date }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="!item.children.find((v) => v.hasValue)"
                class="text-gray-400"
              >
                暂未填写
              </div>
            </div>
            <div v-else class="text-gray-400 text-base">
              <div
                v-for="(
                  moduleVal, moduleValIndex
                ) in formateArchivesModuleValue(item, false)"
                :key="moduleValIndex"
              >
                <span>{{ moduleVal.label }} </span>
                <template v-if="!moduleVal.isLabel">
                  <template
                    v-if="moduleVal && moduleVal.opt && moduleVal.opt.isFile"
                  >
                    <span class="align-middle">：</span>
                    <div
                      v-for="(val, valIdx) in moduleVal.value"
                      :key="valIdx"
                      class="inline-block mr-2 drop-shadow"
                    >
                      <el-image
                        v-if="
                          moduleVal &&
                          moduleVal.opt &&
                          moduleVal.opt.isImage(val.url)
                        "
                        :src="val.url"
                        :alt="val.name"
                        :preview-src-list="moduleVal.value.map((v) => v.url)"
                        preview-teleported
                        :initial-index="valIdx"
                        fit="cover"
                        class="h-12 w-12 rounded align-middle"
                      ></el-image>
                      <el-button
                        v-else
                        class="align-middle"
                        type="primary"
                        link
                        tag="a"
                        :download="val.name"
                        :href="
                          val.url +
                          '?response-content-type=application/octet-stream'
                        "
                        target="_blank"
                        >下载附件</el-button
                      >
                    </div>
                  </template>
                  <span v-else class="text-gray-400"
                    >：{{ moduleVal.value }}{{ moduleVal.unit }}</span
                  >
                </template>
                <div v-if="moduleVal.date">
                  <span>检查时间：</span
                  ><span class="text-gray-400">{{ moduleVal.date }}</span>
                </div>
              </div>

              <div v-if="!item.hasValue" class="text-gray-400">暂未填写</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <el-drawer v-model="submoduleConfig.show" direction="rtl" class="filter-container w-full rounded-l-lg" :with-header="false" size="60%">
      <h3 class=" text-xl mb-4">{{ submoduleConfig.name }}</h3>
      <div class="rounded-lg bg-gray-50 overflow-hidden">
        <div
          v-for="(item, index) in submoduleConfig.list"
          :key="index"
          class="py-2 px-4 border-0 border-b last:border-b-0 hover:bg-gray-100 border-gray-200 border-solid"
        >
          <div class="flex flex-row justify-between items-center">
            <div>
              <div class="text-lg leading-8">{{ item.name }}</div>
              <div class="text-gray-500 text-base">
                <div v-for="(moduleVal, moduleValIndex) in formateArchivesModuleValue(item, true)" :key="moduleValIndex">
                  <span>{{ moduleVal.label }}</span>
                  <span class="text-gray-400">：{{ moduleVal.value }}{{ moduleVal.unit }}</span>
                  <div v-if="moduleVal.date"><span>检查时间：</span><span class="text-gray-400">{{ moduleVal.date }}</span></div>
                </div>
                <div v-if="!item.hasValue" class="text-gray-400">暂未填写</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer> -->
  </div>
</template>
<script>
import * as question from "../../constant/question";
export default {
  data() {
    return {
      // list: [],
      curIdx: 0,
      moduleList: [],
      fileList: [],
      // transferRawJson: undefined,
    };
  },
  props: {
    id: [Number, String],
    isPlat: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: undefined,
    },
    moduleId: {
      type: String,
      default: undefined,
    },
    list: {
      type: Array,
      default: () => [],
    },
    transferRawJson: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    isImage(url) {
      return /^https?:\/\/(.+\/)+.+(\.(gif|png|jpg|jpeg|webp|svg|psd|bmp|tif))$/i.test(
        url
      );
    },

    fetchModuleIndicators() {
      this.getFillFormData();
    },
    async getFillFormData() {
      const returnAnswer = {};
      console.log(this.transferRawJson);
      (this.transferRawJson || []).forEach((v, k) => {
        returnAnswer[v.answer.questionNo] = v.answer;
      });
      console.log("return answer", returnAnswer);

      this.fillFormData(this.list, returnAnswer);
      console.log(this.list);
    },
    async fillFormData(arr, data) {
      arr.forEach((v) => {
        if (v.fields.length) {
          v.fields.forEach((filed) => {
            if (filed.extra.subjects) {
              filed.extra.subjects.forEach((subject) => {
                subject.returnAnswer = data[subject.sn];
              });
            } else {
              if (filed.extra.sn) {
                filed.extra.returnAnswer = data[filed.extra.sn];
              }
            }
          });
        }
        if (v.extra && v.extra.subjects) {
          v.extra.subjects.forEach((subject) => {
            subject.returnAnswer = data[subject.sn];
          });
        } else {
          if (v.extra && v.extra.sn) {
            v.extra.returnAnswer = data[v.extra.sn];
          }
        }
      });
      return arr;
    },

    /*******
     *  @description: 序列化显示档案值
     *  @return { * }
     */
    formateArchivesModuleValue(item, hasValue = true) {
      console.log(item.name, item);
      const list = [];
      if (item.fields.length) {
        item.fields.forEach((filed) => {
          if (filed.extra.subjects) {
            filed.extra.subjects.forEach((subject) => {
              this.formatModuleItemValue(
                subject.name || subject.title,
                subject,
                list
              );
            });
          } else {
            if (filed.extra.sn) {
              this.formatModuleItemValue(
                filed.extra.name || filed.extra.title,
                filed.extra,
                list
              );
            }
          }
        });
      }
      if (item.extra && item.extra.subjects) {
        item.extra &&
          item.extra.subjects.forEach((subject) => {
            this.formatModuleItemValue(
              subject.name || subject.title,
              subject,
              list
            );
          });
      } else {
        if (item.extra && item.extra.sn) {
          this.formatModuleItemValue(
            item.extra.name || item.extra.title,
            item.extra,
            list
          );
        }
      }
      if (hasValue) {
        item.hasValue = !!list.length;
        return list;
      } else {
        const filterList = list.filter((v) => v.value || v.value === 0);
        item.hasValue = !!filterList.length;
        return filterList;
      }
    },

    formatModuleItemValue(label, subject, list, isPush = true) {
      const { returnAnswer } = subject;
      let opt = undefined;
      const validator = JSON.parse(subject.validator);
      if (returnAnswer) {
        let value;
        switch (returnAnswer.type) {
          case question.QUESTION_TYPE_CHECKBOX:
            // value = returnAnswer.checkboxAnswers.map((v) => v.value);
            value = returnAnswer.checkboxAnswers.map((v) => {
              const choice =
                validator.choices.find &&
                validator.choices.find((v2) => v2.attr == v.key);
              return choice.isInput ? choice.label + ":" + v.value : v.value;
            });
            break;
          case question.QUESTION_TYPE_RADIO:
            // value = returnAnswer.answer.value;const choice = validator.choices.find && validator.choices.find(
            const choice =
              validator.choices.find &&
              validator.choices.find(
                (v2) => v2.attr == returnAnswer.answer.key
              );
            value = choice.isInput
              ? choice.label + ":" + returnAnswer.answer.value
              : returnAnswer.answer.value;

            break;
          case question.QUESTION_TYPE_INPUT:
            value = returnAnswer.inputAnswers.value;
            break;
          case question.QUESTION_TYPE_UPLOAD:
            value = returnAnswer.inputAnswers.value;
            opt = {
              isImage: this.isImage(value),
              isFile: true,
            };
            break;
          case question.QUESTION_TYPE_DATE:
            value = returnAnswer.answer.value;
            break;
          case question.QUESTION_TYPE_MATRIX:
            value = returnAnswer.matrixAnswers.map(
              (v) => `${v.xText}${v.yText}`
            );
            break;
          case question.QUESTION_TYPE_GROUP:
            {
              console.log(subject);
              console.log("validator", validator);
              const temp = {};
              returnAnswer.groupAnswers.forEach((arr) => {
                arr.forEach((v, k) => {
                  if (!temp[k]) {
                    temp[k] = [];
                  }
                  temp[k].push(
                    this.formatModuleItemValue(
                      validator.children[k].title,
                      {
                        ...validator.children[k],
                        returnAnswer: v,
                      },
                      list,
                      false
                    )
                  );
                });
              });
              (temp[0] || []).forEach((_, valIdx) => {
                Object.keys(temp).forEach((i) => {
                  const label = validator.children[i].title;
                  list.push({
                    label,
                    value: Array.isArray(temp[i][valIdx])
                      ? temp[i][valIdx].join()
                      : temp[i][valIdx],
                    // value: Array.isArray(temp[i]) ? temp[i].join() : temp[i]
                  });
                });
              });
              console.log("temp", temp);
            }
            break;
        }
        isPush &&
          list.push({
            label,
            value: Array.isArray(value) ? value.join() : value,
            opt,
          });
        return value;
        // return isJoinVal ? (Array.isArray(value) ? value.join() : value) : value
      }
    },
  },
  watch: {
    list: {
      handler(n) {
        console.log(n);
        if (n && n.length) {
          console.log("获取的List", n);
          this.getFillFormData();
        }
      },
      deep: true,
    },
  },
  mounted() {
    // this.getDetail();
  },
};
</script>
<style lang="less" scoped>
.component-archives-module-view {
}
.item {
  background: rgba(0, 0, 0, 0);
  border: 1px solid #dcdfe6;
}
.item-name {
  color: #333;
}
</style>
